var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q3"},[(_vm.name === 'fatfish')?_c('Q3Demo',{attrs:{"name":_vm.name}}):_c('Q3Demo',{attrs:{"name":_vm.name}}),_c('button',{on:{"click":_vm.onClick}},[_vm._v("click")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }